// Is this even useful / Will it be used?
export const ONE_SECOND = 1000;
export const ONE_MINUTE = ONE_SECOND * 60;
export const FIVE_MINUTES = ONE_MINUTE * 5; // Maybe just use ONE_MINUTE * 5 where needed in code?
export const ONE_HOUR = ONE_MINUTE * 60;
